import { DateTime } from "luxon";
import { useMemo, useState } from "react";
import { useEveryMinute } from "./useNowEveryMinute";

/**
 * `compute(now)`, re-read every minute and when the page is back in view, re-rendering only when the result changes
 * (`Object.is`) — for a clock-dependent value inside a large screen that shouldn't re-render just because a minute
 * passed. `compute` must be memoized; a new one is read at once with the current time, never a stale tick's.
 */
export const useValueEveryMinute = <T>(compute: (now: DateTime) => T): T => {
	const [reads, setReads] = useState(0);
	// biome-ignore lint/correctness/useExhaustiveDependencies: `reads` carries no value — it re-reads the clock when a tick saw a change.
	const value = useMemo(() => compute(DateTime.now()), [compute, reads]);
	useEveryMinute(() => {
		if (!Object.is(compute(DateTime.now()), value)) setReads((count) => count + 1);
	});
	return value;
};
